import { ListFilter } from './ListFilter';

export interface ExamCenterListFilter extends ListFilter {
  testareaId: number;
}
